import {BaseDTO} from "./_baseDTO.interface";
import {AdvertDTO} from "./advertDTO.interface";

export interface WatchlistDTO extends BaseDTO {
  advertId: string;
  contactId: string;
  advert?: AdvertDTO;
}
